import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMasked from "react-input-mask";
import moment from "moment";
import Tour from "reactour";
import $ from "jquery";

import { Container, Row } from "react-bootstrap";

//Services
import api from "../../../service/api";

//Components
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Table from "../../../components/Table";
import SideContainerAnimated from "../../../components/SideContainer";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input/index";
import Button from "../../../components/Button/index";
import DropdownButton from "../../../components/DropdownButton";
import Modal from "../../../components/ModalSuccessMessage";
import ErrorMessage from "../../../components/ErrorMessage";
import ModalActions from "../../../components/ModalActions";
import PaymentHistoryItem from "../../../components/PaymentItem";
import { TitleTour, ContentText } from "../../../components/ReactourComponents/styles";
import Animation from "../../../components/Animation/animation";

//Styles
import {  Legend, THead, Th, ThFilterable, Td } from "./styles";

//Routes
import routes from "../../../routes/subscription.routes";

//Help Function
import { openModal } from "../../../helpers/modalFunctions";

//Help Variables
import { serverPath } from "../../../helpers/helpersVariables";

//Assets
import addSubscription from "../../../assets/icons/addSubscription.svg";
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
import search from "../../../assets/icons/search.svg";
import colors from "../../../assets/css/colors";

//Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { ToastContainer } from "react-toastify";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import { calcExpDate } from "../../../utils/calcDateExpiration";

const Subscriptions = () => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);

  const [subscriptionData, setSubscriptionData] = useState<Array<any>>([]);
  const [subscriptionSelected, setSubscriptionSelected] = useState<any>({});
  const [paymentHistory, setPaymentHistory] = useState([]);

  const [errorOnSubmit, setErrorOnSubmit] = useState(false);
  const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [dateForExpiration, setDateForExpiration] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  const [recurrence, setRecurrence] = useState({
    id: "",
    name: "",
    planIdAdquirente: "",
    amount: "",
    description: "",
    frequency: "",
    duration: 0
  });
  const [debouncedRecurrenceName, setDebouncedRecurrenceName] = useState("");
  const [recurrenceSearchDataResults, setRecurrenceSearchDataResults] = useState<Array<any>>([]);

  const [buyer, setBuyer] = useState({
    id: "",
    firstName: "",
    lastName: "",
    buyerIdAdquirente: ""
  });
  const [debouncedBuyerName, setDebouncedBuyerName] = useState("");
  const [buyerSearchDataResults, setBuyerSearchDataResults] = useState<Array<any>>([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [tourUpdateIsOpen, setTourUpdateIsOpen] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const history = useHistory();
  
  useEffect(() => {
      if(login.user.groups.cm5a1 === false){
          history.push("/admin/dashboard");
      }

      const pastVersions: any = JSON.parse(localStorage.getItem("versions") || "{}");
   
      if(pastVersions[login.user.id] === undefined){
        setTourUpdateIsOpen(true);

        const addNewVersion = {
          ...pastVersions,
          [login.user.id]: [
            "1.0.2"
          ]
        }

        localStorage.setItem("versions", JSON.stringify(addNewVersion));
      } else {
        if(!pastVersions[login.user.id].includes("1.0.2")){
          setTourUpdateIsOpen(true);

          console.log(pastVersions);
  
          const addNewVersion = {
            ...pastVersions,
            [login.user.id]: [
              ...pastVersions[login.user.id],
              "1.0.2"
            ]
          }

          localStorage.setItem("versions", JSON.stringify(addNewVersion));
        }
      }
      
  }, []);

  useEffect(() => {
    const getSubscriptionData = async () => {
      const {data} = await api.get("/subscription/list", {
        params: {
          page,
          branchsId: login.user.branchsId
        }
      });

      setSubscriptionData(data.Subscriptions);
      setMaxPage(data.pageCount);
      setIsLoading(false);
    }

    if(searchTerm === ""){
      getSubscriptionData();
    }
  }, [page, searchTerm]);

  useEffect(() => {
    setIsLoading(true);
    const timerId = setTimeout(() => {
        setPage(1);
        setDebouncedSearchTerm(searchTerm);
    }, 1200);

    return () => {
        clearTimeout(timerId);
    }
  }, [searchTerm]);

  useEffect(() => {
    const getSubscriptionsFilteredAtApi = async () => {
      const {data} = await api.get("/subscription/list", {
        params: {
          page,
          branchsId: login.user.branchsId,
          search: debouncedSearchTerm
        }
      });

      setMaxPage(data.pageCount)
      setSubscriptionData(data.Subscription);
      setIsLoading(false);
    }

    if(debouncedSearchTerm !== ""){
      getSubscriptionsFilteredAtApi();
    }
  }, [debouncedSearchTerm, page]);

  useEffect(() => {
      const timerId = setTimeout(() => {
          setDebouncedRecurrenceName(recurrence.name);
      }, 300);
      
      return () => {
          clearTimeout(timerId);
      }
  }, [recurrence.name]);

  useEffect(() => {
      const getRecurrencePlansAtApi = async () => {

          const {data} = await api.get(`/adm/ownerbranch/list?id=${login.user.branchsId}&filter=${debouncedRecurrenceName}`);
          
          setRecurrenceSearchDataResults(data.Recurrence)
      }

      if(debouncedRecurrenceName !== ""){
        getRecurrencePlansAtApi();
      }
  }, [debouncedRecurrenceName]);

  useEffect(() => {
      const timerId = setTimeout(() => {
          setDebouncedBuyerName(buyer.firstName);
      }, 300);
      
      return () => {
          clearTimeout(timerId);
      }
  }, [buyer.firstName]);

  useEffect(() => {
      const getBuyersAtApi = async () => {

          const {data} = await api.get("/buyer/list", {
              params: {
                  branchsId: login.user.branchsId,
                  search: debouncedBuyerName
              }
          });

          setBuyerSearchDataResults(data.Buyer)
      }
    
      if(debouncedBuyerName !== ""){
          getBuyersAtApi();
      }
  }, [debouncedBuyerName]);

  const formValidationWithYup = Yup.object().shape({
    dateForNextPayment: Yup.string().required(),
    amount: Yup.string().required(),
  });

  const searchForErrors = (errors: Object) => {
    if(errors !== {}){
      setErrorOnSubmit(true)
    } else {
      setErrorOnSubmit(false)
    }
  }

  const openAddForm = () => {
    if(isEditFormVisible != true) {
        setIsAddFormVisible(true);
    }
  }

  const openEditForm = () => {
    if(isAddFormVisible != true) {
        setIsEditFormVisible(true);
    }
  }

  const openPaymentHistory = async (subscription: any) => {
    const {data} = await api.get("/subscription/list", {
      params: {
        idSubscriptionAdquirente: subscription.sb_idSubscriptionAdquirente
      }
    });

    setPaymentHistory(data.buyerSubscription[0].Subscription);
    setSubscriptionSelected({
      ...subscription,
      ...data.buyerSubscription[0].Branch
    });
    openModal("payment-history");
  }

  const getDueData = (date: string) => {

    const dateWithoutTime = date.split("T");
    
    return moment(dateWithoutTime[0]).format("DD/MM/YYYY");
  }

  const getSubscriptionAmount = (amount: string) => {
    return (parseInt(amount) / 100).toLocaleString("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2});
  }

  const handleExport = async () => {
    const { data } = await api.get("/subscription/list", {
      params: {
        branchsId: login.user.branchsId,
        exportFilter: true
      }
    });

    window.open(`${serverPath}/${data}`);
  }

  const suspendSubscription = async (subscription: any) => {

    await api.put("/subscription/update?status=suspend", {
      "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
      "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
      "idSubscriptionAdquirente": subscription.sb_idSubscriptionAdquirente,
      "id": subscription.sb_id
    });

    const {data} = await api.get("/subscription/list", {
      params: {
        page,
        branchsId: login.user.branchsId
      }
    });

    setSubscriptionData(data.Subscriptions);
    setMaxPage(data.pageCount);
  }

  const reactiveSubscription = async (subscription: any) => {

    await api.put("/subscription/update?status=active", {
      "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
      "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
      "idSubscriptionAdquirente": subscription.sb_idSubscriptionAdquirente,
      "id": subscription.sb_id
    });

    const {data} = await api.get("/subscription/list", {
      params: {
        page,
        branchsId: login.user.branchsId
      }
    });

    setSubscriptionData(data.Subscriptions);
    setMaxPage(data.pageCount);
  }

  function tableContentGenerator() {
    return subscriptionData.map((subscription, index) => (
      <tr key={subscription.sb_id} style={{ height: 67 }}>
        <Td>{subscription.sb_id}</Td>
        <Td>{subscription.bu_firstName}</Td>
        <Td>{subscription.bu_lastName}</Td>
        <Td>{subscription.sb_status === "active" ? "Ativo" : "Inativo"}</Td>
        <Td>{subscription.bu_taxpayerId}</Td>
        <Td>{subscription.sb_name}</Td>
        <Td>{getDueData(subscription.sb_due_date)}</Td>
        <Td>R$ {getSubscriptionAmount(subscription.sb_amount)}</Td>
        <Td>
          <DropdownButton
            id={`dropdown-${index}`}
            isSubscription={true}
            subscriptionStatus={subscription.sb_status}
            selectedUser={subscription}
            suspendSubscription={suspendSubscription}
            reactiveSubscription={reactiveSubscription}
            isViewOptionVisible={true}
            setIsViewFormVisible={() => openPaymentHistory(subscription)}
          />
        </Td>
      </tr>
    ));
  }

  const orderName = [
    "Primeira",
    "Segunda",
    "Terceira",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sétima",
    "Oitava",
    "Nona",
    "Décima",
    "Décima primeira",
    "Décima segunda",
  ];

  const paymentItemGenerator = () => {
    return paymentHistory.map((paymentItem: any, index) => {
      return <PaymentHistoryItem 
        order={ subscriptionSelected.pl_duration <= 12 ? `${orderName[index]}` : `${index + 1}/${subscriptionSelected.pl_duration}`} 
        status={paymentItem.tr_status} 
        subscriptionDescription={subscriptionSelected.sb_description}
        transactionDate={moment(paymentItem.tr_dueDate).add(3, "hours").format("DD/MM/YYYY")}
        key={paymentItem.tr_id}
      />
    })
  }

  const steps = [
    {
      selector: "",
      content: () => (
        <>
          <TitleTour>Novidade</TitleTour>
          <ContentText>Agora você pode visualizar as transações referentes a uma assinatura</ContentText>
        </>
      )
    },
    {
      selector: "#dropdown-0",
      content: () => (
        <>
          <TitleTour>Novidade</TitleTour>
          <ContentText>Para fazer isso, clique no botão de mais opções na assinatura escolhida</ContentText>
        </>
      )
    },
    {
      selector: "#dropdown-0",
      content: () => (
        <>
          <TitleTour>Novidade</TitleTour>
          <ContentText>Em seguida clique em "Visualizar", caso haja transações relacionadas a essa assinatura, elas serão exibidas</ContentText>
        </>
      )
    },

  ]

  const openForm =  isAddFormVisible || isEditFormVisible;

  const createSubscriptions = async (values: any) => {
    try{
      let dueDate: Array<string> | string = values.dateForNextPayment.split("/");
      let expirationDate: Array<string> | string = calcExpDate(values.dateForNextPayment, recurrence.duration, recurrence.frequency).split("/");
      
      dueDate = `${dueDate[2]}-${dueDate[1]}-${dueDate[0]}`;
      expirationDate = `${expirationDate[2]}-${expirationDate[1]}-${expirationDate[0]}`

      values.amount = parseFloat(values.amount.replace(",", ".")).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2});
      let amountInCents = parseFloat(values.amount.replace(",", ".").replaceAll(".", ""));

      await api.post("/subscription/create", {  
        "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
        "apiOwnerId": "ZOOP", //login.user.branchs.apiOwner.id
        "idPlanAdquirente": recurrence.planIdAdquirente,
        "idBuyerAdquirente": buyer.buyerIdAdquirente,
        "amount": Math.round(amountInCents),
        "name": recurrence.name,
        "description": recurrence.description,
        "due_date": dueDate,
        "buyer100PayId": buyer.id,
        "branchId": login.user.branchsId,
        "owner100PayId": login.user.branchs.sellerOwner100PayId,
        "planRecurrenceId": recurrence.id,
        "expiration_date": expirationDate
      });

      const {data} = await api.get("/subscription/list", {
        params: {
          page,
          branchsId: login.user.branchsId
        }
      });

      setSubscriptionData(data.Subscriptions);
      setMaxPage(data.pageCount);
      setErrorOnReturnApi(false);
      toastUpdate("btnSubmit", "success", 3000, "Sucesso")
      openModal("exampleModal");
    } catch (e){
      setErrorOnReturnApi(true);
      toastUpdate("btnSubmit","error",4000, "Ocorreu um problema, entre em contato com o suporte." )
    }
  }
  
  return (
    <Container fluid>
      <ToastContainer/>
      <Row>
        <Modal text="Assinatura gerada com Sucesso"/>
        <ModalActions title="Histórico de pagamento" id="payment-history">
          { paymentHistory.length > 0 ? 
              paymentItemGenerator() : 
              <ErrorMessage>
                Não foi encontrada nenhuma transação relacionada a essa assinatura.
              </ErrorMessage>
          }
        </ModalActions>
        <Tour
          steps={steps}
          isOpen={tourUpdateIsOpen}
          onRequestClose={() => setTourUpdateIsOpen(false)}
          accentColor={colors.primary}
          showNumber={false}
          showNavigation
          showNavigationNumber={false}
          showButtons
        />
        <Main className={` ${openForm ? "col-d-none column-side-open" : "column-content"} `} isFormVisible={isAddFormVisible}>
          
            <Header
                title="Assinatura"
                subTitle="Gere pagamentos via boleto bancário de forma fácil e rápida."
                subTitleWidth={236}
            />
            <NavTabs tabs={routes}/>
            
            <Table
                showAddButton={login.user.groups.cm5a1c}
                showExportButton={login.user.groups.cm5a1e}
                handleExport={handleExport}
                buttonText="Gerar Assinatura"
                isAddFormVisible={isAddFormVisible}
                setIsAddFormVisible={openAddForm}
                page={page}
                maximumPage={maxPage}
                setPage={setPage}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
            >
              <THead>
                <tr>
                  <ThFilterable>
                    <div>ID</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                  <Th>Primeiro Nome</Th>
                  <Th>Último Nome</Th>
                  <ThFilterable>
                    <div>Status</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                  <Th>Cpf</Th>
                  <Th>Nome do plano</Th>
                  <Th>Cobrança inicial</Th>
                  <Th>Valor cobrança</Th>
                  <Th></Th>
                </tr>
              </THead>
              {
                isLoading 
                ? <Animation/>
                : <tbody>
                    { tableContentGenerator() }
                </tbody>
              }
            </Table>

        </Main>

        <SideContainerAnimated isVisible={isAddFormVisible}>
          <SideForm title="Gerar Assinatura" icon={addSubscription} visible={setIsAddFormVisible}>
            <Formik 
              initialValues={{
                // plan: recurrence.name,
                // buyer: buyer.name,
                dateForNextPayment: "",
                amount: "",
              }}
              validationSchema={formValidationWithYup}
              onSubmit={(values) => {
                createSubscriptions(values);
              }}
            >
              {({ initialValues, values, errors, handleChange, handleSubmit}) => {
                if(recurrence.amount !== ""){
                  initialValues.amount = (parseInt(recurrence.amount) / 100).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})
                }

                return (
                  <Form id="form-subscription" style={{ width: "100%", marginTop: 41 }}>
                    <fieldset>
                      <Legend>Dados Principais</Legend>
                      <div className="inputWithIcon">
                          <Input 
                            className="inputCustom" 
                            type="search"
                            autoComplete="off"
                            style={{borderColor: `${errorOnSubmit && recurrence.id === "" ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                            placeholder="Plano de Recorrência" 
                            isSearchField={true}
                            setValue={setRecurrence}
                            searchResults={recurrenceSearchDataResults}
                            searchType="name"
                            value={recurrence.name}
                            onChange={(e: any) => {
                              setRecurrence({
                                id: recurrence.id,
                                planIdAdquirente: recurrence.planIdAdquirente,
                                amount: recurrence.amount,
                                name: e.target.value,
                                description: recurrence.description,
                                frequency: recurrence.frequency,
                                duration: recurrence.duration
                              });
                            }}
                          />
                          <img src={search}/>
                      </div>
                      <div className="inputWithIcon">
                          <Input
                            className="inputCustom"
                            style={{borderColor: `${errorOnSubmit && buyer.buyerIdAdquirente === "" ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                            placeholder="Comprador"
                            isSearchField={true}
                            setValue={setBuyer}
                            searchResults={buyerSearchDataResults}
                            searchType="name"
                            value={buyer.firstName}
                            onChange={(e: any) => {
                              setBuyer({
                                id: buyer.id, 
                                firstName: e.target.value,
                                lastName: buyer.lastName,
                                buyerIdAdquirente: buyer.buyerIdAdquirente
                              });
                            }}
                          />
                          <img src={search}/>
                      </div>
                      <Field 
                        name="dateForNextPayment" 
                      >
                        {() => (
                          <InputMasked
                            id="dateForNextPayment" 
                            className="input-masked inputCustom" 
                            style={{borderColor: `${errorOnSubmit && errors.dateForNextPayment ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                            mask="99/99/9999" 
                            placeholder="Data Próxima Cobrança"
                            onChange={handleChange}
                          />
                        )}
                      </Field>
                      <Field 
                        id="amount" 
                        name="amount" 
                        className="inputCustom" 
                        style={{borderColor: `${errorOnSubmit && errors.amount ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                        placeholder="Valor" 
                        as={Input}
                      />
                      <Field 
                        disabled
                        name="dateForExpiration"
                        style={{cursor: "no-drop"}} 
                        value={
                          calcExpDate(values.dateForNextPayment, recurrence.duration, recurrence.frequency) === "Data inválida"
                          ? "Data de expiração"
                          : calcExpDate(values.dateForNextPayment, recurrence.duration, recurrence.frequency)
                        }
                        as={Input}
                      />

                    </fieldset>
                    {
                      errorOnSubmit && buyer.buyerIdAdquirente === "" 
                      ? toastUpdate("btnSubmit","warning",3000,"Selecione um plano de recorrência" )
                      : null
                    }
                    {
                      errorOnSubmit && recurrence.id === "" 
                      ? toastUpdate("btnSubmit","warning",3000,"Selecione um comprador" )
                      : null
                    }
                    {notifysFieldsForm(errors, errorOnSubmit)}
                    {
                      errorOnReturnApi ? 
                        <ErrorMessage>
                          Falha ao criar assinatura
                        </ErrorMessage> : null
                    }

                    <Button 
                      type="submit" 
                      className="buttonCustom"
                      onClick={() => {
                        searchForErrors(errors);
                        toastCreate("btnSubmit", "info", 3000, "Processando")
                      }}
                      >
                        Adicionar
                      </Button>
                  </Form>
                )
              }}
            </Formik>
          </SideForm>
        </SideContainerAnimated>
      </Row>
    </Container>
  );
};

export default Subscriptions;